import _orderBy from 'lodash/orderBy';
import { createSelector } from 'reselect';

import { categoriesSelectors } from '../categories';
import { transactionRulesSelectors } from './transactionRulesSlice';
import { TransactionRuleType } from './transactionRulesTypes';
import { getDuplicateTransactionRuleId, getFilteredTransactionRules, getRuleHash } from './transactionRulesUtils';

const getSortedRules = createSelector(transactionRulesSelectors.selectAll, (rules: TransactionRuleType[]) => {
  return _orderBy(rules, ['modifiedAt'], ['desc']);
});

// return a sorted list of rules with a hashkey which we will use to identify duplicate rules
export const getRules = createSelector(getSortedRules, (rules: TransactionRuleType[]) => {
  return rules.map((rule) => {
    return { ...rule, hashKey: getRuleHash(rule) };
  });
});

export const getDuplicateRuleId = createSelector(
  transactionRulesSelectors.selectAll,
  (_state: any, rule: TransactionRuleType) => rule,
  (rules, rule) => getDuplicateTransactionRuleId(rules, rule),
);

export const getFilteredRules = createSelector(
  transactionRulesSelectors.selectAll,
  (_state: any, searchValue: string) => searchValue,
  categoriesSelectors.getCategoriesById,
  (rules, searchValue, categories) => getFilteredTransactionRules(rules, searchValue, categories),
);
